import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const is3DExhibitionEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('e3dExhibition'),
)

export default is3DExhibitionEnabledSelector
